import apiClient from './apiClient';

class WhatsAppService {
  // Send WhatsApp to campaign target with optional recipient override
  async sendCampaignTargetInvitation(targetId, overrideRecipient = null) {
    try {
      const requestBody = {
        targetId,
        ...(overrideRecipient && { overrideRecipient })
      };
      
      const response = await apiClient.post('/whatsapp/campaign/target/invite', requestBody);
      return {
        success: true,
        data: response.data,
        message: response.data.message
      };
    } catch (error) {
      console.error('WhatsApp send error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to send WhatsApp',
        error: error.response?.data?.error
      };
    }
  }

  // Send bulk WhatsApp to multiple campaign targets
  async sendBulkCampaignInvitation(campaignId, targetIds = [], options = {}) {
    try {
      const requestBody = {
        campaignId,
        targetIds,
        ...options
      };

      const response = await apiClient.post('/whatsapp/campaign/bulk-invite', requestBody);
      return {
        success: true,
        data: response.data,
        message: response.data.message
      };
    } catch (error) {
      console.error('Bulk WhatsApp send error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to send bulk WhatsApp',
        error: error.response?.data?.error
      };
    }
  }

  // Get WhatsApp service status
  async getStatus() {
    try {
      const response = await apiClient.get('/whatsapp/status');
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('WhatsApp status error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to get WhatsApp status',
        error: error.response?.data?.error
      };
    }
  }
}

// Create and export a singleton instance
const whatsappService = new WhatsAppService();
export default whatsappService;